const schoolData = [
  {
    _id: "59f733edf6a3ec117bea6269",
    arrow: `<i class="fa fa-arrow-down" aria-hidden="true" />`,
    URN: "101494",
    LAESTAB: "3803377",
    name: "Peel Park Primary School and Nursery",
    phase: "Primary",
    type: "Community School",
    sixthForm: "Does not have a sixth form",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD2 4PR",
    pupils: "641",
    inspectionDate: "05/05/2016",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "2",
    outcomes: "2",
    quality: "2",
    personalDev: "2",
    leadership: "2",
    prevInspectionDate: "09/04/2014",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "9",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "2",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.73499676924206, 53.8074122035828],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63b4",
    arrow: `<i class="fa fa-arrow-down" aria-hidden="true" />`,
    URN: "107208",
    LAESTAB: "3802036",
    name: "Byron Primary School",
    phase: "Primary",
    type: "Community School",
    sixthForm: "Does not have a sixth form",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD3 0AB",
    pupils: "707",
    inspectionDate: "14/12/2016",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "2",
    outcomes: "2",
    quality: "2",
    personalDev: "2",
    leadership: "2",
    prevInspectionDate: "04/12/2014",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "2",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "3",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.73005465579254, 53.7990243913995],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63b9",
    arrow: `<i class="fa fa-arrow-down" aria-hidden="true" />`,
    URN: "107220",
    LAESTAB: "3802057",
    name: "Swain House Primary School",
    phase: "Primary",
    type: "Community School",
    sixthForm: "Does not have a sixth form",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD2 1JL",
    pupils: "525",
    inspectionDate: "11/10/2011",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "2",
    outcomes: "2",
    quality: "2",
    personalDev: "9",
    leadership: "2",
    prevInspectionDate: "12/05/2009",
    prevTotalScore: "2",
    prevStudyProg: "9",
    prevEarlyYears: "2",
    prevOutcomes: "2",
    prevQuality: "2",
    prevPersonalDev: "9",
    prevLeadership: "2",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.74007386261181, 53.8213097051271],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63be",
    arrow: `<i class="fa fa-arrow-down" aria-hidden="true" />`,
    URN: "107230",
    LAESTAB: "3802071",
    name: "Wellington Primary School",
    phase: "Primary",
    type: "Community School",
    sixthForm: "Does not have a sixth form",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD2 3DE",
    pupils: "509",
    inspectionDate: "06/12/2013",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "9",
    outcomes: "2",
    quality: "2",
    personalDev: "9",
    leadership: "2",
    prevInspectionDate: "25/01/2011",
    prevTotalScore: "2",
    prevStudyProg: "9",
    prevEarlyYears: "2",
    prevOutcomes: "2",
    prevQuality: "2",
    prevPersonalDev: "9",
    prevLeadership: "2",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.73076129305418, 53.8119686608907],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63c6",
    arrow: `<i class="fa fa-arrow-down" aria-hidden="true" />`,
    URN: "107242",
    LAESTAB: "3802093",
    name: "Grove House Primary School",
    phase: "Primary",
    type: "Community School",
    sixthForm: "Does not have a sixth form",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD2 4ED",
    pupils: "449",
    inspectionDate: "13/01/2016",
    totalScore: "3",
    studyProg: "9",
    earlyYears: "2",
    outcomes: "3",
    quality: "3",
    personalDev: "2",
    leadership: "3",
    prevInspectionDate: "21/11/2013",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "9",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "3",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.74166870098217, 53.8163877520523],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63cb",
    arrow: `<i class="fa fa-arrow-up" aria-hidden="true" />`,
    URN: "107249",
    LAESTAB: "3802103",
    name: "Fagley Primary School",
    phase: "Primary",
    type: "Community School",
    sixthForm: "Does not have a sixth form",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD2 3PU",
    pupils: "307",
    inspectionDate: "22/03/2017",
    totalScore: "1",
    studyProg: "9",
    earlyYears: "1",
    outcomes: "1",
    quality: "1",
    personalDev: "1",
    leadership: "1",
    prevInspectionDate: "08/02/2012",
    prevTotalScore: "2",
    prevStudyProg: "9",
    prevEarlyYears: "8",
    prevOutcomes: "2",
    prevQuality: "2",
    prevPersonalDev: "9",
    prevLeadership: "2",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.7170458673255, 53.8099597469838],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63f7",
    arrow: `<i class="fa fa-arrow-up" aria-hidden="true" />`,
    URN: "107325",
    LAESTAB: "3803334",
    name: "St Clare's Catholic Primary School",
    phase: "Primary",
    type: "Voluntary Aided School",
    sixthForm: "Does not have a sixth form",
    religion: "Roman Catholic",
    localAuth: "Bradford",
    postcode: "BD2 3JD",
    pupils: "196",
    inspectionDate: "17/06/2016",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "2",
    outcomes: "2",
    quality: "2",
    personalDev: "2",
    leadership: "2",
    prevInspectionDate: "13/02/2014",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "9",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "3",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.71772044228658, 53.8090086111238],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63fc",
    arrow: `<i class="fa fa-arrow-up" aria-hidden="true" />`,
    URN: "107332",
    LAESTAB: "3803351",
    name: "St Francis Catholic Primary School",
    phase: "Primary",
    type: "Voluntary Aided School",
    sixthForm: "Does not have a sixth form",
    religion: "Roman Catholic",
    localAuth: "Bradford",
    postcode: "BD2 4ES",
    pupils: "243",
    inspectionDate: "17/01/2013",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "9",
    outcomes: "2",
    quality: "2",
    personalDev: "9",
    leadership: "2",
    prevInspectionDate: "03/11/2010",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "1",
    prevOutcomes: "3",
    prevQuality: "2",
    prevPersonalDev: "9",
    prevLeadership: "2",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.73827841620267, 53.8169106944863],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea640a",
    arrow: `<i class="fa fa-arrow-up" aria-hidden="true" />`,
    URN: "107431",
    LAESTAB: "3805200",
    name: "Killinghall Primary School",
    phase: "Primary",
    type: "Foundation School",
    sixthForm: "Does not have a sixth form",
    religion: "None",
    localAuth: "Bradford",
    postcode: "BD3 7JF",
    pupils: "744",
    inspectionDate: "11/07/2013",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "9",
    outcomes: "2",
    quality: "2",
    personalDev: "9",
    leadership: "1",
    prevInspectionDate: "22/02/2007",
    prevTotalScore: "1",
    prevStudyProg: "9",
    prevEarlyYears: "2",
    prevOutcomes: "1",
    prevQuality: "2",
    prevPersonalDev: "9",
    prevLeadership: "1",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.72243253510565, 53.8014247655825],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea63ea",
    arrow: `<i class="fa fa-arrows-h" aria-hidden="true" />`,
    URN: "107305",
    LAESTAB: "3803021",
    name: "St Luke's CofE Primary School",
    phase: "Primary",
    type: "Voluntary Controlled School",
    sixthForm: "Does not have a sixth form",
    religion: "Church of England",
    localAuth: "Bradford",
    postcode: "BD2 3NS",
    pupils: "208",
    inspectionDate: "05/05/2016",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "3",
    outcomes: "2",
    quality: "2",
    personalDev: "2",
    leadership: "2",
    prevInspectionDate: "14/03/2014",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "9",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "3",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.71827318348951, 53.8149060162657],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea6408",
    arrow: `<i class="fa fa-arrows-h" aria-hidden="true" />`,
    URN: "107413",
    LAESTAB: "3804100",
    name: "Carlton Bolling College",
    phase: "Secondary",
    type: "Community School",
    sixthForm: "Has a sixth form",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD3 0DU",
    pupils: "1501",
    inspectionDate: "15/10/2015",
    totalScore: "3",
    studyProg: "3",
    earlyYears: "9",
    outcomes: "3",
    quality: "3",
    personalDev: "3",
    leadership: "3",
    prevInspectionDate: "20/06/2014",
    prevTotalScore: "4",
    prevStudyProg: "9",
    prevEarlyYears: "9",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "4",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.73867434207201, 53.8020814142991],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea6412",
    arrow: `<i class="fa fa-arrows-h" aria-hidden="true" />`,
    URN: "107440",
    LAESTAB: "3805401",
    name: "Hanson School",
    phase: "Secondary",
    type: "Foundation School",
    sixthForm: "Has a sixth form",
    religion: "None",
    localAuth: "Bradford",
    postcode: "BD2 1JP",
    pupils: "1504",
    inspectionDate: "25/02/2015",
    totalScore: "4",
    studyProg: "3",
    earlyYears: "9",
    outcomes: "4",
    quality: "4",
    personalDev: "9",
    leadership: "4",
    prevInspectionDate: "27/02/2013",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "9",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "3",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.74324310922076, 53.8197256613502],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea6617",
    arrow: `<i class="fa fa-arrows-h" aria-hidden="true" />`,
    URN: "136962",
    LAESTAB: "3804613",
    name: "Feversham College",
    phase: "Secondary",
    type: "Academy Converter",
    sixthForm: "Has a sixth form",
    religion: "Muslim",
    localAuth: "Bradford",
    postcode: "BD3 0LT",
    pupils: "752",
    inspectionDate: "17/01/2008",
    totalScore: "1",
    studyProg: "1",
    earlyYears: "9",
    outcomes: "1",
    quality: "1",
    personalDev: "9",
    leadership: "1",
    prevInspectionDate: "NULL",
    prevTotalScore: "NULL",
    prevStudyProg: "NULL",
    prevEarlyYears: "NULL",
    prevOutcomes: "NULL",
    prevQuality: "NULL",
    prevPersonalDev: "NULL",
    prevLeadership: "NULL",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.74607794251059, 53.805566669874],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea665a",
    arrow: `<i class="fa fa-arrows-h" aria-hidden="true" />`,
    URN: "138867",
    LAESTAB: "3802007",
    name: "Feversham Primary Academy",
    phase: "Primary",
    type: "Academy Sponsor Led",
    sixthForm: "Not applicable",
    religion: "None",
    localAuth: "Bradford",
    postcode: "BD3 9EG",
    pupils: "495",
    inspectionDate: "26/09/2014",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "2",
    outcomes: "2",
    quality: "2",
    personalDev: "9",
    leadership: "2",
    prevInspectionDate: "NULL",
    prevTotalScore: "NULL",
    prevStudyProg: "NULL",
    prevEarlyYears: "NULL",
    prevOutcomes: "NULL",
    prevQuality: "NULL",
    prevPersonalDev: "NULL",
    prevLeadership: "NULL",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.72817157154287, 53.7944003139954],
      type: "Point"
    }
  },
  {
    _id: "59f733edf6a3ec117bea65e8",
    arrow: `<i class="fa fa-arrows-h" aria-hidden="true" />`,
    URN: "135235",
    LAESTAB: "3807035",
    name: "Delius Special School",
    phase: "Special",
    type: "Community Special School",
    sixthForm: "Not applicable",
    religion: "Does not apply",
    localAuth: "Bradford",
    postcode: "BD3 8QX",
    pupils: "124",
    inspectionDate: "19/06/2013",
    totalScore: "2",
    studyProg: "9",
    earlyYears: "9",
    outcomes: "2",
    quality: "2",
    personalDev: "9",
    leadership: "2",
    prevInspectionDate: "12/05/2011",
    prevTotalScore: "3",
    prevStudyProg: "9",
    prevEarlyYears: "2",
    prevOutcomes: "3",
    prevQuality: "3",
    prevPersonalDev: "9",
    prevLeadership: "3",
    __v: 0,
    location: {
      index: "2d",
      coordinates: [-1.72611149487134, 53.7983773068918],
      type: "Point"
    }
  }
];

export default schoolData;



// WEBPACK FOOTER //
// ./src/components/schoolComponents/schoolData.js